export const getQueryParamFromSrcAsset = () => {
  let currentSrc = (window.document.currentScript?.getAttribute('src') || '').trim();

  if (!currentSrc.startsWith('http')) {
    currentSrc = window.location.origin + currentSrc;
  }

  const assetUrl = new URL(currentSrc);
  return Object.fromEntries(assetUrl.searchParams);
};

export const shortAssetTags = (player: string, lumenId?: string) => {
  const assets = [
    'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
    `${__PIXELS_JS_ENDPOINT__}/vertical-player.main.js?v=${__SHA__}`,
    `${__PIXELS_JS_ENDPOINT__}/vertical-player.main.css?v=${__SHA__}`,
    `${__SHORT_ENDPOINT__}/build/${player}/shorts-autoplay.js?v=${__SHA__}`,
    `${__SHORT_ENDPOINT__}/build/${player}/shorts-autoplay.css?v=${__SHA__}`,
  ];

  if (lumenId) {
    return [`${__SHORT_ENDPOINT__}/omweb-v1.js`, `${__SHORT_ENDPOINT__}/omid-session-client-v1.js`, ...assets];
  }

  return assets;
};

export const getPageUrl = () => {
  try {
    return document.querySelector('link[rel=canonical]').getAttribute('href');
  } catch (ex) {
    return document.location.href;
  }
};
